import React from 'react'
import styled from '@emotion/styled'
import LogoSvg from 'src/assets/images/logo.svg'
import { animations } from 'src/styles'

const LogoWrapper = styled.div`
	height: auto;
	display: inline-block;
	vertical-align: top;
	svg {
		overflow: visible;
		display: inline-block;
		vertical-align: top;
		width: 100%;
		height: auto;
		color: inherit;
		.letter {
			transition: opacity ${ animations.mediumSpeed } ease-in-out, transform ${ animations.mediumSpeed } ease-in-out;
			&:nth-of-type(2) { transition-delay: ${ 40 * 1 }ms; }
			&:nth-of-type(3) { transition-delay: ${ 40 * 2 }ms; }
			&:nth-of-type(4) { transition-delay: ${ 40 * 3 }ms; }
			&:nth-of-type(5) { transition-delay: ${ 40 * 4 }ms; }
			&:nth-of-type(6) { transition-delay: ${ 40 * 5 }ms; }
			&:nth-of-type(7) { transition-delay: ${ 40 * 6 }ms; }
		}
	}
	${ ({ hideText }) => hideText ? `
		svg {
			.letter {
				opacity: 0;
				transform: translateY(5px);
			}
		}
	` : '' }
`

const Logo = ({ className, mobileMenuOpen }) => (
	<LogoWrapper className={className} hideText={mobileMenuOpen}>
		<LogoSvg />
	</LogoWrapper>
)

export const Logomark = ({ className }) => (
	<LogoWrapper className={className}>
		<LogoSvg />
	</LogoWrapper>
)

export default Logo
